// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `footer.csss .background {
  height: 237px;
  width: 100%;
  z-index: -1;
  position: absolute;
  left: 0px;
  background-color: #424242 !important;
}

.footerContainer {
  padding: 3% 12%;
}

.login-ft-btn {
  font-size: 16px;
  font-weight: 500;
  background-color: transparent;
  border-radius: 4px;
  color: #68ad3f;
  border: 3px solid #68ad3f;
  width: 80px;
  height: 42px;
}

.login-ft-btn:hover {
  background-color: #fbb040;
  border: 2px solid #fbb040 !important;
  color: white;
}

.signup-btn:hover {
  background-color: #fbb040;
  color: white;
}

.signup-btn {
  font-size: 16px;
  font-weight: 500;
  background-color: #68ad3f;
  border-radius: 4px;
  color: white;
  border: none;
  margin-left: 28px;
}

.link {
  color: white;
  font-size: 18px;
}

.footer-bottom div {
  margin-left: 2%;
}

.footer-top {
  display: flex;
  justify-content: space-between;
  margin: 2% 0;
}

.logsignbtns button {
  padding: 8px 11px;
  width: unset !important;
  height: unset !important;
}

@media (max-width: 481px) {
  .signup-btn {
    width: 70px !important;
    height: auto !important;
    font-size: 12px !important;
    margin-left: 12px !important;
  }

  .login-ft-btn {
    width: 70px !important;
    height: auto !important;
    font-size: 12px !important;
    padding: 8px !important;
    border: 4px solid;
  }

  .link {
    font-size: 12px;
  }

  .background {
    height: 130px !important;
  }

  .footer-top {
    margin: 6% 0;
  }

  .footer-top img {
    width: 85%;
  }
}

@media (max-width: 1024px) {
  .footer-top {
    margin: 5% 0;
  }

  .background {
    height: 230px;
  }

  .footer-top img {
    width: 85%;
  }
}

#mailIcon {
  color: white !important;
}
`, "",{"version":3,"sources":["webpack://./src/Feis-Homepage/Footer.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,oCAAoC;AACtC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,oCAAoC;EACpC,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;EACE;IACE,sBAAsB;IACtB,uBAAuB;IACvB,0BAA0B;IAC1B,4BAA4B;EAC9B;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,0BAA0B;IAC1B,uBAAuB;IACvB,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,uBAAuB;AACzB","sourcesContent":["footer.csss .background {\n  height: 237px;\n  width: 100%;\n  z-index: -1;\n  position: absolute;\n  left: 0px;\n  background-color: #424242 !important;\n}\n\n.footerContainer {\n  padding: 3% 12%;\n}\n\n.login-ft-btn {\n  font-size: 16px;\n  font-weight: 500;\n  background-color: transparent;\n  border-radius: 4px;\n  color: #68ad3f;\n  border: 3px solid #68ad3f;\n  width: 80px;\n  height: 42px;\n}\n\n.login-ft-btn:hover {\n  background-color: #fbb040;\n  border: 2px solid #fbb040 !important;\n  color: white;\n}\n\n.signup-btn:hover {\n  background-color: #fbb040;\n  color: white;\n}\n\n.signup-btn {\n  font-size: 16px;\n  font-weight: 500;\n  background-color: #68ad3f;\n  border-radius: 4px;\n  color: white;\n  border: none;\n  margin-left: 28px;\n}\n\n.link {\n  color: white;\n  font-size: 18px;\n}\n\n.footer-bottom div {\n  margin-left: 2%;\n}\n\n.footer-top {\n  display: flex;\n  justify-content: space-between;\n  margin: 2% 0;\n}\n\n.logsignbtns button {\n  padding: 8px 11px;\n  width: unset !important;\n  height: unset !important;\n}\n\n@media (max-width: 481px) {\n  .signup-btn {\n    width: 70px !important;\n    height: auto !important;\n    font-size: 12px !important;\n    margin-left: 12px !important;\n  }\n\n  .login-ft-btn {\n    width: 70px !important;\n    height: auto !important;\n    font-size: 12px !important;\n    padding: 8px !important;\n    border: 4px solid;\n  }\n\n  .link {\n    font-size: 12px;\n  }\n\n  .background {\n    height: 130px !important;\n  }\n\n  .footer-top {\n    margin: 6% 0;\n  }\n\n  .footer-top img {\n    width: 85%;\n  }\n}\n\n@media (max-width: 1024px) {\n  .footer-top {\n    margin: 5% 0;\n  }\n\n  .background {\n    height: 230px;\n  }\n\n  .footer-top img {\n    width: 85%;\n  }\n}\n\n#mailIcon {\n  color: white !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
